import React, {Fragment, useState} from 'react'// eslint-disable-line
import clsx from 'clsx';
import {createUseStyles} from 'react-jss';
import {TABLE} from '../../common-styles/style-table';
import {COLORS} from '../../utils/style-variables';
import {BranchPopup} from '../branch-popup';
import {getKzDateTime, platform} from '../../utils/helpers';
import {LocationLink} from '../common/location-link';
import {GOOGLE_SEARCH} from '../../utils/constants';
import {infoIcon} from '../../common-styles/icons-style';
import {ModalBase} from '../modal-base';
import {Phones} from '../phones';

const useStyles = createUseStyles({
  row: {
    extend: TABLE.row
  },
  bankUpdate: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 16px',
    backgroundColor: COLORS.backgroundGreyColor,
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    borderBottomColor: COLORS.lightGrey30Color,
    '@media (max-width: 768px)': {
      padding: '10px 8px'
    }
  },
  updateTime: {
    color: COLORS.greyColor
  },
  branchTitle: {
    color: COLORS.greyColor
  },
  showOnMap: {
    color: COLORS.blue100Color,
    fontWeight: 500,
    '& > svg': {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: 8,
      marginBottom: 3,
      '& > path': {
        fill: COLORS.blue100Color
      }
    }
  },
  branch: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  information: {
    width: 'calc(100% - 150px)',
    paddingRight: 30,
    position: 'relative',
    '@media (max-width: 768px)': {
      width: '100%',
      paddingRight: 40,
      extend: infoIcon
    }
  },
  title: {
    '@media (max-width: 768px)': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  address: {
    color: COLORS.greyColor,
    '@media (max-width: 768px)': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  phones: {
    width: 150,
    '& span': {
      display: 'block'
    }
  },
  whiteBg: {
    backgroundColor: '#ffffff'
  },
  showBranchLocation: {
    '& > svg': {
      display: 'inherit'
    }
  }
});

const renderBranches = (data, bank, selectedLocation, callPopup) => {
  const classes = useStyles();

  return data.branches.map(branch => (
    <div key={branch.title} className={clsx(classes.row, classes.branch)}>
      <div
        className={classes.information}
        onClick={() => callPopup(branch)}
      >
        <p className={classes.title}>
          <b>{branch.title || 'Отделение'}</b>
        </p>
        <p className={classes.address}>{branch.address}</p>
      </div>
      {platform.desktop ?
        <div className={classes.phones}>
          <Phones phones={branch.phones} maxItems={3} />
        </div>
        :
        null
      }
      {branch.location && platform.desktop ?
        <LocationLink
          link={`${GOOGLE_SEARCH}&query=${branch.location.lat},${branch.location.lng}`}
          iconProps={{width: 12, height: 17}}
          style={classes.showBranchLocation}
        />
        : null
      }
    </div>
  ));
};

const modalHoc = Wrapped => props => {
  const [modal, setModal] = useState({isOpen: false});

  return (
    <Fragment>
      <Wrapped {...props} setModal={setModal} />
      <ModalBase isOpen={modal.isOpen} setModal={setModal}>
        <BranchPopup data={modal} />
      </ModalBase>
    </Fragment>
  );
};

const branches = ({data: {bank, bankBranches, selectedLocation}, setModal}) => {
  const classes = useStyles();
  const callPopup = branchData => (platform.mobile ? setModal({isOpen: true, branchData, bank}) : false);

  return (
    <div className={classes.branchList}>
      {platform.mobile ?
        <Fragment>
          <div className={clsx(classes.bankUpdate, classes.whiteBg)}>
            <span>Обновленно</span>
            <span className={classes.updateTime}>
              {bank.lastReceivedRatesTime ? getKzDateTime(bank.lastReceivedRatesTime, 'time') : '-'}
            </span>
          </div>
          <div className={classes.bankUpdate}>
            <div className={classes.branchTitle}>Отделения</div>
          </div>
        </Fragment>
        :
        null
      }
      {renderBranches(bankBranches, bank, selectedLocation, callPopup)}
    </div>
  );
};

export const Branches = modalHoc(branches);
